import * as React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import * as colors from '../../../shared/colors';
import { formatYMD, parseDate } from '../../../shared/dateFns';
import t from '../../../shared/translations';
import { ITeamScan } from './Landing';

interface IProps {
    teamScan: ITeamScan;
}

const box = css`
    border: 1px solid ${colors.primaryColor};
    background-color: white;
    width: 600px;
    max-width: 100%;
    display: block;
    margin-bottom: 1rem;
    text-align: center;
    padding: 1.6rem 0.6rem;
    color: ${colors.primaryColor};

    &:hover, &:focus, &:active {
        color: ${colors.primaryColor};
    }
`;

const LinkBox = styled(Link)`
    ${box}
`;

const LinkAnchor = styled.a`
    ${box}
`;

function TeamScanBox({ teamScan }: IProps): JSX.Element {
    let pathName = null;
    if (teamScan?.submittedTaskVariant?.submittedTask?.learningPathItem?.learningPath) {
        pathName = <><br />{teamScan?.submittedTaskVariant?.submittedTask?.learningPathItem?.learningPath?.pathname}</>;
    }
    switch (teamScan.status) {
        case 'setup-survey':
            return <LinkBox to={`setup/${teamScan.id}`}>
                {t('player.team-scan-landing.box-create')}
                {pathName}
            </LinkBox>;
        case 'do-survey':
            return <LinkAnchor href={teamScan.myLink}>
                {t('player.team-scan-landing.box-answer')}
                {pathName}
            </LinkAnchor>;
        case 'waiting-for-responses':
            const [complete, total] = teamScan.progress;
            return <LinkBox to={`progress/${teamScan.id}`}>
                {t('player.team-scan-landing.box-progress', { complete, total })}
                {pathName}
            </LinkBox>;
        case 'reporting':
            return <LinkBox to={`report/${teamScan.id}`}>
                {t('player.team-scan-landing.box-result', { date: formatYMD(parseDate(teamScan.reportDatetime)) })}
                {pathName}
            </LinkBox>;
    }
}

export default React.memo(TeamScanBox);
